<div class="horizontal-container center-children" [title]="listedBatteries">
    <div class="fill right-buffer">
        <status-icon [batterySet]="item" [clickable]="false"></status-icon>
    </div>
    <div class="fill vertical-container">
        <div class="wrap-overflow">
            {{ item.batteries[0]?.batteryTypeMake }}
            {{ item.batteries[0]?.batteryTypeModel }}
        </div>
        <div *ngIf="showOwner" class="wrap-overflow">
            Owner:
            {{ item.organisation.name }}
        </div>
        <div *ngIf="showCustodian" class="wrap-overflow">
            Custodian:
            {{ item.custodian | formatOrganisation | defaultTo: 'Owner' }}
        </div>
    </div>
</div>
